import { useRoles } from './api.js';

interface RolePickerProps {
  selectedIds: string[];
  onChange: (roleIds: string[]) => void;
  disabled?: boolean;
}

/** Checkbox list for assigning roles to a member or API user. */
export function RolePicker({ selectedIds, onChange, disabled }: RolePickerProps): JSX.Element {
  const query = useRoles({ page: 1, pageSize: 200 });
  const roles = query.data?.data ?? [];

  const toggle = (id: string): void => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((roleId) => roleId !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  return (
    <div>
      <p className="mb-2 text-xs font-medium uppercase tracking-wide text-slate-500">Roles</p>
      {query.isLoading ? (
        <p className="text-sm text-slate-500">Loading roles…</p>
      ) : query.isError ? (
        <p className="text-sm text-rose-600">Failed to load roles.</p>
      ) : roles.length === 0 ? (
        <p className="text-sm text-slate-500">No roles available. Create a role first.</p>
      ) : (
        <div className="flex flex-col gap-1 rounded-lg border border-slate-200 p-3">
          {roles.map((role) => (
            <label key={role.id} className="flex items-center gap-2 text-sm text-slate-700">
              <input
                type="checkbox"
                checked={selectedIds.includes(role.id)}
                onChange={() => toggle(role.id)}
                disabled={disabled}
                className="rounded border-slate-300 text-brand-600 focus:ring-brand-500"
              />
              {role.name}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
